import { render } from "./SimpleNoteDetailTabShipping.vue?vue&type=template&id=36107212"
import script from "./SimpleNoteDetailTabShipping.vue?vue&type=script&lang=js"
export * from "./SimpleNoteDetailTabShipping.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__